var viewer_rtlignore_default = {
  "gallery_container": "K--x-",
  "imageTitleContainer": "AduKe",
  "clickableItem": "pyuE7",
  "prerender": "CXgqF",
  "expandButton": "_01I7r",
  "itemContainer": "RMrFk",
  "expandIcon": "ZtbYl",
  "itemOverlay": "V-zot",
  "imageTitle": "ycWsB",
  "pointer": "TRTgY",
  "fadeIn": "IV6p6",
  "changing_background": "RWHUf"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
